import usFlag from './us_flag.svg';

export const USFlag = ({ styles }: { styles?: React.CSSProperties }) => (
  <img
    src={usFlag}
    alt="United State of America Flag"
    style={{ ...styles, maxWidth: '140%', maxHeight: '85px' }}
  />
);
